module.exports = __webpack_public_path__ + "static/media/berklee-wide.47a82bcd.png";